document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-ir-ps]');
  if (!root) return;

  const slides = root.querySelectorAll('.ir-ps__slide');
  const thumbs = root.querySelectorAll('.ir-ps__thumb');
  const prevBtn = root.querySelector('[data-ir-ps-prev]');
  const nextBtn = root.querySelector('[data-ir-ps-next]');

  let current = 0;
  const total = slides.length;

  function goTo(index) {
    if (index < 0) index = total - 1;
    if (index >= total) index = 0;

    slides.forEach(s => s.classList.remove('is-active'));
    thumbs.forEach(t => t.classList.remove('is-active'));

    slides[index].classList.add('is-active');
    thumbs[index].classList.add('is-active');

    current = index;
  }

  thumbs.forEach(btn => {
    btn.addEventListener('click', function () {
      const index = parseInt(this.getAttribute('data-index'), 10);
      goTo(index);
    });
  });

  prevBtn.addEventListener('click', function () {
    goTo(current - 1);
  });

  nextBtn.addEventListener('click', function () {
    goTo(current + 1);
  });
});
